import { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import getInputValidationClasses from "../../../lib/helpers/getInputValidationClasses"
import { InputDescription } from "../../common/form/input"
import { textarea } from "../../common/form/input.module.css"
import { input } from "../../common/form/input.module.css"
import InputGroup from "../../common/form/inputGroup"
import Label from "../../common/form/label"
import { useActiveStep } from "../store"

export default function Greetings({ giftType }) {
  const { greetings } = useActiveStep()
  const removeEmojis = function (string) {
    var regex =
      /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
    return string.replace(regex, "")
  }

  const { register, watch, setValue, control } = useFormContext({
    defaultValues: {
      greeting: greetings[0].text,
      greetingText: greetings[0].text
    }
  })

  const maxLength = 120
  const greetingValue = watch("greeting")
  const [errorTextarea, setErrorTextarea] = useState(false)
  const [greetingLength, setGreetingLength] = useState(0)

  useEffect(() => {
    setValue("greetingText", greetingValue)
    setGreetingLength(greetingValue?.length ? greetingValue?.length : 0)
  }, [greetingValue])

  function getNumberOfLines(text) {
    return (text.match(/\n/g) || []).length + 1;
  }

  return (
    <>
      {giftType == "memorialGift" && (
        <InputGroup>
          <Label name="greetingText">Din personliga minneshälsning</Label>
          <div className="relative">
            <select
              {...register("greeting")}
              id="greeting"
              className="block w-full py-2 pl-4 pr-8 text-lg leading-tight bg-white border rounded appearance-none border-black-50 focus:outline-none focus:shadow-outline">
              {greetings.map((greeting, index) => (
                <option key={index} value={greeting.text}>
                  {greeting.title}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 top-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
              <svg
                className="w-4 h-4 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </InputGroup>
      )}

      <InputGroup>
        {giftType !== "memorialGift" && (
          <Label name="greetingText">Din hälsning</Label>
        )}
        <textarea
          id="greetingText"
          {...register("greetingText")}
          placeholder="Skriv din egen hälsning här. Lämna fältet tomt om du vill fylla i för hand."
          onKeyDown={(event) => {
            if (
              getNumberOfLines(event.target.value) > 3 &&
              event.key === "Enter"
            ) {
              event.preventDefault()
            }
          }}
          onKeyUp={(event) => {
            if (getNumberOfLines(event.target.value) > 4) {
              setErrorTextarea(true)
              return
            }
            setErrorTextarea(false)
          }}
          onChange={(event) => {
            setGreetingLength(event.target.value.length)
            event.target.value = removeEmojis(event.target.value)
          }}
          maxLength={maxLength}
          className={[
            textarea,
            getInputValidationClasses("greetingText", control)
          ].join(" ")}
        />
        <InputDescription>
          {maxLength - greetingLength} tecken kvar att skriva. Max 4 rader.
        </InputDescription>

        {errorTextarea && (
          <span className="mt-1 text-xs text-red-100">
            Hälsningen får bara innehålla 4 rader.
          </span>
        )}
      </InputGroup>

      <InputGroup>
        <Label required={true} name="sender">
          Avsändare
        </Label>
        <input
          id="sender"
          {...register("sender", {
            required: true
          })}
          className={[input, getInputValidationClasses("sender", control)].join(
            " "
          )}
        />
      </InputGroup>
    </>
  )
}
